import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";

import type {
	ProfileCategory,
	ProfileItem,
	ProfileItemFormValues,
} from "../models/ProfileItem";

export const getProfileCategories = async (
	defaultAreaId: string | number | null | undefined,
	signal?: AbortSignal,
): Promise<ProfileCategory[]> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2(
		"[DIM].[GetProfileCategories]",
		[{ name: "AssetId", value: Number(defaultAreaId) }],
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching item categories");
	}

	return get(resp, "data.tables[0].rows", []) as ProfileCategory[];
};

export const getProfileItems = async (
	defaultAreaId: string | number | null | undefined,
	signal?: AbortSignal,
): Promise<ProfileItem[]> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2(
		"[DIM].[GetProfileItems]",
		[{ name: "AssetId", value: Number(defaultAreaId) }],
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching section dimensions");
	}

	return get(resp, "data.tables[0].rows", []) as ProfileItem[];
};

export const upsertProfileItem = async (
	item: ProfileItemFormValues,
): Promise<void> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ProfileItemId", value: item.ProfileItemId },
		{ name: "ProfileCategoryId", value: item.ProfileCategoryId },
		{ name: "Code", value: item.Code },
		{ name: "Name", value: item.Description },
		{ name: "ValueTypeCode", value: item.ValueTypeCode },
	];

	const resp = await apiService.callV2("[DIM].[UpsertProfileItem]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error saving section dimension");
	}
};

export const deleteProfileItems = async (
	profileItemIds: number[],
): Promise<void> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ProfileItemIdsJson", value: JSON.stringify(profileItemIds) },
	];

	const resp = await apiService.callV2("[DIM].[DeleteProfileItem]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting section dimension");
	}
};

export const deleteProfileItem = async (profileItemId: number): Promise<void> =>
	deleteProfileItems([profileItemId]);
